<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md6 class="content-title">
                <h2>Recibos</h2>
                <h4>Confira seus recibos de pagamentos de comissões de agenciamento/corretagem.</h4>
            </v-flex>
            <v-flex md6>
                &nbsp;<v-btn color="info" :outlined="filtroMeses == 1 ? false : true" @click="aplicarFiltro(1)"><v-icon>mdi-calendar-multiple-check</v-icon>&nbsp; Último mês</v-btn>
                &nbsp;<v-btn color="info" :outlined="filtroMeses == 6 ? false : true" @click="aplicarFiltro(6)"><v-icon>mdi-calendar-multiple-check</v-icon>&nbsp; Último semestre</v-btn>
                &nbsp;<v-btn color="info" :outlined="filtroMeses == 12 ? false : true" @click="aplicarFiltro(12)"><v-icon>mdi-calendar-multiple-check</v-icon>&nbsp; Último ano</v-btn>
            </v-flex>
            <v-flex md12>
                <br>
                <div class="line"></div>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="comissoes"
                    :items-per-page="topItems"
                    :loading="loading"
                    loading-text="Carregando... Por favor aguarde."
                    :sort-by="['dataPagamento']"
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"                    
                    :sort-desc="[true]"                       
                    class="">

                    <template v-slot:item.tipoComissao="{ item }">
                        {{ tipoComissao(item.tipoComissao) }}
                    </template>

                    <template v-slot:item.dataPagamento="{ item }">
                        {{ item.dataPagamento | formatDateBR }}
                    </template>

                    <template v-slot:item.formaPagamento="{ item }">
                        {{ formaPagamento(item.formaPagamento) }}
                    </template>

                    <template v-slot:item.valorBruto="{ item }">
                        {{ formatPrice(item.valorBruto - (item.impostoRendaRetido + item.valorInss + item.valorIss)) }}
                    </template>

                    <template v-slot:item.excel="{ item }">
                        <img class="hover" v-if="item.tipoSistema.toUpperCase() != 'I4PRO'" src="/img/icon-xls.png" @click="gerarExcel(item)" />
                        <span v-if="item.tipoSistema.toUpperCase() == 'I4PRO'">--</span>
                    </template>
                    <template v-slot:item.pdf="{ item }">
                        <img class="hover" src="/img/icon-pdf.png" @click="gerarPDF(item)" />
                    </template>
                </v-data-table>
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-layout>
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                filtroMeses: 1,
                loading: true,
                fullLoading: false,
                topItems: 10,
                offset: 1,
                options: {},
                headers: [
                    {text: "Recibo", value: "numeroRecibo", sortable: true},
                    {text: "Tipo", value: "tipoComissao", sortable: true},
                    {text: "Data", value: "dataPagamento", sortable: true},
                    {text: "Forma de Pagamento", value: "formaPagamento", sortable: true},
                    {text: "Valor (R$)", value: "valorBruto", sortable: true},
                    {text: "Download (Excel)", value: "excel", sortable: false},
                    {text: "Download (PDF)", value: "pdf", sortable: false}
                ],
                comissoes: []
            }
        },        
        methods: {
            requestComissoes(){
                this.loading = true;
                this.fullLoading = true;

                let codigoCorretor = this.usuario.codCorretor;                

                let url = "ResumoPagamentoComissao/Recibo/"+codigoCorretor+"/"+this.filtroMeses;
                 
                // Request comissoes
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.comissoes = res.data;
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });        
            },
            aplicarFiltro(value){
                this.filtroMeses = value;
                this.offset = 1;
                this.requestComissoes();
            },
            gerarExcel(value){
                let numeroRecibo = value.numeroRecibo;
                let url = this.baseURL + "Emissao/ReciboComissaoExcel/"+numeroRecibo;
                window.open(url, "_blank");
            },
            gerarPDF(value){
                let numeroRecibo = value.numeroRecibo;
                let url = this.baseURL + "Emissao/ReciboComissaoPdf/"+numeroRecibo;

                if (value.tipoSistema.toUpperCase() ==  'I4PRO')
                {
                    url = value.linkReciboComissao;
                } 

                window.open(url, "_blank");
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            tipoComissao(value){
                if(value == "COR")
                    return "Corretagem";
                if(value == "PRO")
                    return "Pró-Labore";
                if(value == "AGE")
                    return "Agenciamento";

                return value;
            },
            formaPagamento(value){
                if(value == "CRE")
                    return "CRÉDITO EM C.C.";

                return value;
            }
        },
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        filters: {
            formatDateBR(value){
                if (value) {
                    return moment(String(value)).format('DD/MM/YYYY');
                }
            }
        },
        mounted(){            
            this.requestComissoes()
        },
    }
</script>
